// Runtime JS (CRA) — allineato a index.ts (sanità, costa, civici, trasporti, tradizioni)
import abbaziaData from "./abbazia_montesanto.json";
import goleData from "./gole_salinello.json";
import fortezzaData from "./fortezza_civitella.json";
import campliData from "./campli_data.json";
import crognaletoData from "./crognaleto_data.json";
import torricellaData from "./torricella_sicura_data.json";
import castelTrosinoData from "./castel_trosino_data.json";
import moscianoData from "./mosciano_sant_angelo_data.json";
import castiglioneData from "./castiglione_messer_raimondo_data.json";
import ospitalitaData from "./hospitality.json";
import { HERO_BY_SLUG } from "../../utils/heroImages";
import { SIXAMICO_MEDIA } from "../sixamicoMedia";

export function generaSanitaDefault(provincia, farmacieLocali = []) {
  return {
    dsb_riferimento: `DSB (Distretto Sanitario di Base) - ASL ${provincia}`,
    centrale_guardia_medica_telefono:
      "116117 (Numero Europeo Armonizzato Cure Non Urgenti)",
    emergenza_sanitaria: "118",
    farmacie: farmacieLocali,
  };
}

/** Calcolo geografico reale da Civitella del Tronto verso le Sette Sorelle. */
export const DISTANZE_SETTE_SORELLE = [
  { nome: "Martinsicuro", dist: "23 km", tempo: "24 min", via: "SP1 Val Vibrata" },
  { nome: "Alba Adriatica", dist: "22 km", tempo: "25 min", via: "SP1 / Casello A14" },
  { nome: "Tortoreto", dist: "25 km", tempo: "28 min", via: "SP1 / SP8" },
  { nome: "Giulianova", dist: "32 km", tempo: "35 min", via: "SS81 / Superstrada Teramo-Mare" },
  { nome: "Roseto degli Abruzzi", dist: "44 km", tempo: "42 min", via: "A14 (Uscita Teramo/Giulianova)" },
  { nome: "Pineto", dist: "50 km", tempo: "48 min", via: "Autostrada A14" },
  { nome: "Silvi", dist: "55 km", tempo: "52 min", via: "Autostrada A14" },
];

export const DISTANZE_SETTE_SORELLE_CIVITELLA = DISTANZE_SETTE_SORELLE;

/** Hub costa picena (Castel Trosino / Ascoli). */
export const DISTANZE_COSTA_PICENA = [
  { nome: "San Benedetto del Tronto", dist: "28 km", tempo: "30 min", via: "Raccordo Ascoli-Mare" },
  { nome: "Grottammare", dist: "30 km", tempo: "32 min", via: "Raccordo Ascoli-Mare / SS16" },
  { nome: "Cupra Marittima", dist: "35 km", tempo: "38 min", via: "SS16 Adriatica" },
];

export function generaCostaTeramanaDefault(distanzaKm, minutiAuto, viePrincipali, distanzeHub) {
  const hubSource = distanzeHub && distanzeHub.length ? distanzeHub : DISTANZE_SETTE_SORELLE;
  return {
    hub_balneari_vicini: hubSource.map((h) => h.nome),
    distanza_media_costa_km: distanzaKm,
    principali_vie_connessione: viePrincipali,
    pista_ciclabile_riferimento: "Corridoio Verde Adriatico (Bike to Coast)",
    tempo_percorrenza_auto_min: minutiAuto,
    distanze_sette_sorelle: hubSource,
  };
}

export const features6amicoDefault = {
  has_piazza_social: true,
  has_capsula_memoria: true,
  qr_code_territoriale: {
    disponibile: true,
    protocollo_installazione: "Sentinel Gateway",
  },
  gateway_istituzionali: [
    { nome: "Risorse Ufficiali UNESCO Italia", url: "https://unesco.it" },
  ],
};

export const CANALI_TEMATICI_6AMICO = [
  "BORGHI",
  "OUTDOOR",
  "MARE",
  "NATURA",
  "GUSTO",
  "BENESSERE",
  "NAUTICA",
  "BUSINESS",
  "EVENTI",
  "PODCAST",
  "CULTURA",
  "MONTAGNA",
];

export const CANALE_TEMATICO_META = {
  BORGHI: { label: "Borghi & regioni", href: "/comuni" },
  OUTDOOR: { label: "Tour & escursioni", href: "/tour-escursioni" },
  MARE: { label: "Mare & stabilimenti", href: "/mare-costa" },
  NATURA: { label: "Parchi & natura", href: "/parchi" },
  GUSTO: { label: "Sapori d'Italia", href: "/prodotti" },
  BENESSERE: { label: "Terme & benessere", href: "/terme-benessere" },
  NAUTICA: { label: "Turismo nautico", href: "/turismo-nautico" },
  BUSINESS: { label: "Fiere & convegni", href: "/fiere-convegni" },
  EVENTI: { label: "Eventi & sagre", href: "/eventi" },
  PODCAST: { label: "Podcast & viaggio", href: "/archivio-podcast" },
  CULTURA: { label: "Arte & UNESCO", href: "/passaporto-unesco" },
  MONTAGNA: {
    label: "Montagna & neve",
    href: "/esplora-la-mappa?mode=terra&macro=montagna",
  },
};

/**
 * Alias corti ↔ pillar CanaleTematico6Amico (non inventare significati):
 * BRG→BORGHI, OUT→OUTDOOR, MAR→MARE, NAT→NATURA, GST→GUSTO, BEN→BENESSERE.
 */
export const CANALE_CORTO_TO_TEMATICO = {
  BRG: "BORGHI",
  OUT: "OUTDOOR",
  MAR: "MARE",
  NAT: "NATURA",
  GST: "GUSTO",
  BEN: "BENESSERE",
};

export const CANALE_TEMATICO_TO_CORTO = {
  BORGHI: "BRG",
  OUTDOOR: "OUT",
  MARE: "MAR",
  NATURA: "NAT",
  GUSTO: "GST",
  BENESSERE: "BEN",
};

export const CANALI_CORTI_6AMICO = ["BRG", "OUT", "MAR", "NAT", "GST", "BEN"];

export function expandCanaleCode(code) {
  const u = String(code || "")
    .trim()
    .toUpperCase();
  if (!u) return null;
  if (CANALI_TEMATICI_6AMICO.includes(u)) return u;
  if (Object.prototype.hasOwnProperty.call(CANALE_CORTO_TO_TEMATICO, u)) {
    return CANALE_CORTO_TO_TEMATICO[u];
  }
  return null;
}

export function canaliToCorti(canali) {
  const out = [];
  for (const c of Array.isArray(canali) ? canali : []) {
    const corto = CANALE_TEMATICO_TO_CORTO[c];
    if (corto && !out.includes(corto)) out.push(corto);
  }
  return out;
}

export function canaliFromCorti(canali) {
  const out = [];
  for (const c of Array.isArray(canali) ? canali : []) {
    const full = expandCanaleCode(String(c));
    if (full && !out.includes(full)) out.push(full);
  }
  return out;
}

export function canaliAttiviFromMacro(macro) {
  const m = String(macro || "")
    .trim()
    .toUpperCase();
  if (m === "MARE") {
    return ["BORGHI", "MARE", "NAUTICA", "GUSTO", "EVENTI", "CULTURA"];
  }
  if (m === "MONTAGNA") {
    return ["BORGHI", "MONTAGNA", "OUTDOOR", "NATURA", "EVENTI", "CULTURA"];
  }
  return ["BORGHI", "OUTDOOR", "GUSTO", "NATURA", "EVENTI", "CULTURA"];
}

/** Accetta pillar lunghi e CanaleCorto (BRG, OUT, …). */
export function resolveCanaliAttivi(explicit, macro) {
  const fromSeed = Array.isArray(explicit)
    ? canaliFromCorti(explicit.map((c) => String(c || "")))
    : [];
  if (fromSeed.length > 0) return Array.from(new Set(fromSeed));
  return canaliAttiviFromMacro(macro);
}

export function puntoArToCorto(punto) {
  const src = punto || {};
  const { coordinate, ...rest } = src;
  const c = coordinate || {};
  return {
    ...rest,
    coord: [c.latitudine, c.longitudine],
  };
}

export function puntoArFromCorto(punto) {
  const { coord, ...rest } = punto || {};
  const lat = Number(coord && coord[0]);
  const lng = Number(coord && coord[1]);
  return {
    ...rest,
    coordinate: {
      latitudine: Number.isFinite(lat) ? lat : 0,
      longitudine: Number.isFinite(lng) ? lng : 0,
    },
  };
}

/** Proietta scheda canonica → DTO corto (slug/nome/alt/pop/status/url/canali/coord). */
export function schedaFrazioneToCorta(scheda) {
  return {
    slug: scheda.slug_frazione,
    nome: scheda.nome_frazione,
    alt: scheda.altitudine_m,
    pop: scheda.popolazione_stimata,
    status: scheda.network_status,
    url: scheda.url_scheda_originale,
    canali: canaliToCorti(scheda.canali_attivi),
    punto_ar: puntoArToCorto(scheda.punto_ar),
  };
}

/** Espande DTO corto → campi canonici (identità + canali + punto_ar). */
export function schedaFrazioneFromCorta(corta) {
  return {
    slug_frazione: corta.slug,
    nome_frazione: corta.nome,
    altitudine_m: corta.alt,
    popolazione_stimata: corta.pop,
    network_status: corta.status,
    url_scheda_originale: corta.url,
    canali_attivi: canaliFromCorti(corta.canali),
    punto_ar: puntoArFromCorto(corta.punto_ar),
  };
}

const farmacieCivitella = [
  {
    nome: "Farmacia Comunale Civitella",
    indirizzo: "Corso Mazzini, 45 - Civitella Centro",
    telefono: "+39 0861 91234",
    stato: "Attivo",
  },
  {
    nome: "Farmacia Dr. Russo",
    indirizzo: "Viale Vibrata, 12 - Frazione Villa Lempa",
    telefono: "+39 0861 91789",
    stato: "Attivo",
  },
];

export const sanitaCivitella = generaSanitaDefault("Teramo", farmacieCivitella);

export const costaCivitella = generaCostaTeramanaDefault(
  22,
  25,
  [
    "Strada Provinciale SP1 della Val Vibrata",
    "Raccordo Autostradale A14 (Casello Val Vibrata)",
    "SS16 Adriatica",
  ],
  DISTANZE_SETTE_SORELLE
);

export function generaTrasportiDefault(comuneId = "civitella-del-tronto") {
  const byComune = {
    "civitella-del-tronto": {
      operatore_principale_bus: "TUA (Società Unica Abruzzese di Trasporto)",
      linee_chiave_collegamento: [
        "Linea Diretta Teramo - Civitella del Tronto - Villa Lempa",
        "Linea Intercomunale di Vallata (Val Vibrata - Alba Adriatica / Martinsicuro)",
      ],
      stazione_ferroviaria_piu_vicina: {
        nome: "Stazione di Alba Adriatica - Nereto / Vibrata",
        distanza_km: 21,
      },
    },
    campli: {
      operatore_principale_bus: "TUA (Società Unica Abruzzese di Trasporto)",
      linee_chiave_collegamento: [
        "Collegamenti TUA Teramo – Campli (corridoio collinare teramano)",
        "Collegamenti verso costa adriatica / hub Giulianova",
      ],
      stazione_ferroviaria_piu_vicina: {
        nome: "Stazione di Giulianova",
        distanza_km: 28,
      },
    },
    crognaleto: {
      operatore_principale_bus: "TUA (Società Unica Abruzzese di Trasporto)",
      linee_chiave_collegamento: [
        "Collegamenti TUA valle del Vomano – Crognaleto / Nerito",
        "Accesso montano verso Parco Gran Sasso e Monti della Laga",
      ],
      stazione_ferroviaria_piu_vicina: {
        nome: "Stazione di Teramo",
        distanza_km: 35,
      },
    },
    "torricella-sicura": {
      operatore_principale_bus: "TUA (Società Unica Abruzzese di Trasporto)",
      linee_chiave_collegamento: [
        "Collegamenti TUA Torricella Sicura – Teramo",
        "Accesso pedemontano verso Monti della Laga",
      ],
      stazione_ferroviaria_piu_vicina: {
        nome: "Stazione di Teramo",
        distanza_km: 8,
      },
    },
    "ascoli-piceno": {
      operatore_principale_bus: "Trasporto pubblico locale Marche / Ascoli",
      linee_chiave_collegamento: [
        "Collegamenti Ascoli Piceno – Castel Trosino",
        "Raccordo Ascoli-Mare verso costa picena",
      ],
      stazione_ferroviaria_piu_vicina: {
        nome: "Stazione di Ascoli Piceno",
        distanza_km: 10,
      },
    },
    "mosciano-sant-angelo": {
      operatore_principale_bus: "TUA (Società Unica Abruzzese di Trasporto)",
      linee_chiave_collegamento: [
        "Collegamenti TUA Mosciano – Giulianova / Teramo",
        "Corridoio A14 Casello Giulianova-Mosciano",
      ],
      stazione_ferroviaria_piu_vicina: {
        nome: "Stazione di Giulianova",
        distanza_km: 9,
      },
    },
    "castiglione-messer-raimondo": {
      operatore_principale_bus: "TUA (Società Unica Abruzzese di Trasporto)",
      linee_chiave_collegamento: [
        "Collegamenti TUA Val Fino – Castiglione Messer Raimondo",
        "Collegamenti verso costa (Pineto / A14)",
      ],
      stazione_ferroviaria_piu_vicina: {
        nome: "Stazione di Pineto-Atri",
        distanza_km: 28,
      },
    },
  };
  return byComune[comuneId] || byComune["civitella-del-tronto"];
}

export function generaCiviciDefault(comuneId = "civitella-del-tronto") {
  const byComune = {
    "civitella-del-tronto": {
      municipio_sede: {
        nome: "Comune di Civitella del Tronto",
        indirizzo: "Via d'Ancarano, 1 - Centro Storico",
        orari_sintetici: "Lun-Ven 08:30 - 13:30",
      },
      pro_loco_riferimento: {
        nome: "Pro Loco Civitella del Tronto",
        contatti: "info@prolococivitella.it",
      },
      ricarica_elettrica_ev: true,
      parcheggio_camper_hub:
        "Parcheggio di Porta Napoli (Centro) / Area attrezzata frazione Ripe",
    },
    campli: {
      municipio_sede: {
        nome: "Comune di Campli",
        indirizzo: "Piazza Vittorio Emanuele II, 1 - Palazzo Farnese, 64012 Campli (TE)",
        orari_sintetici: "Lun-Ven 09:00 - 13:00",
      },
      pro_loco_riferimento: {
        nome: "Pro Loco di Campli APS",
        contatti: "Piazza Vittorio Emanuele 1, 64012 Campli",
      },
      ricarica_elettrica_ev: false,
      parcheggio_camper_hub: "Aree sosta centro storico / frazioni (verificare in loco)",
    },
    crognaleto: {
      municipio_sede: {
        nome: "Comune di Crognaleto",
        indirizzo: "Sede municipale in frazione Nerito (TE)",
        orari_sintetici: "Verificare orari sul sito comunale",
      },
      pro_loco_riferimento: {
        nome: "Pro Loco / associazioni frazioni Crognaleto",
        contatti: "Comune di Crognaleto",
      },
      ricarica_elettrica_ev: false,
      parcheggio_camper_hub: "Aree sosta valle del Vomano / frazioni (verificare in loco)",
    },
    "torricella-sicura": {
      municipio_sede: {
        nome: "Comune di Torricella Sicura",
        indirizzo: "Torricella Sicura (TE)",
        orari_sintetici: "Verificare orari sul sito comunale",
      },
      pro_loco_riferimento: {
        nome: "Pro Loco di Torricella Sicura",
        contatti: "Comune di Torricella Sicura",
      },
      ricarica_elettrica_ev: false,
      parcheggio_camper_hub: "Aree sosta pedemontane (verificare in loco)",
    },
    "ascoli-piceno": {
      municipio_sede: {
        nome: "Comune di Ascoli Piceno",
        indirizzo: "Frazione Castel Trosino, 63100 Ascoli Piceno (AP)",
        orari_sintetici: "Verificare orari sul sito comunale",
      },
      pro_loco_riferimento: {
        nome: "Associazione Castrense 96 APS",
        contatti: "https://www.casteltrosino.it/",
      },
      ricarica_elettrica_ev: false,
      parcheggio_camper_hub: "Sosta in prossimità del borgo (verificare in loco)",
    },
    "mosciano-sant-angelo": {
      municipio_sede: {
        nome: "Comune di Mosciano Sant'Angelo",
        indirizzo: "Piazza Aurelio Saliceti / centro, Mosciano Sant'Angelo (TE)",
        orari_sintetici: "Verificare orari sul sito comunale",
      },
      pro_loco_riferimento: {
        nome: "Pro Loco Mosciano Sant'Angelo",
        contatti: "Piazza Aurelio Saliceti, Mosciano Sant'Angelo",
      },
      ricarica_elettrica_ev: false,
      parcheggio_camper_hub: "Aree sosta centro / collina (verificare in loco)",
    },
    "castiglione-messer-raimondo": {
      municipio_sede: {
        nome: "Comune di Castiglione Messer Raimondo",
        indirizzo: "Castiglione Messer Raimondo (TE)",
        orari_sintetici: "Verificare orari sul sito comunale",
      },
      pro_loco_riferimento: {
        nome: "Pro Loco Castiglione Messer Raimondo",
        contatti: "Comune di Castiglione Messer Raimondo",
      },
      ricarica_elettrica_ev: false,
      parcheggio_camper_hub: "Aree sosta Val Fino (verificare in loco)",
    },
  };
  return byComune[comuneId] || byComune["civitella-del-tronto"];
}

/**
 * Default enogastronomici per regione — solo seed UI / fallback.
 * Non sono un registro DE.C.O./DOP certificato: preferire sempre
 * `tradizioni_cultura` / `specialita_culinarie` della frazione o Albo comunale.
 */
export function generaEnogastronomiaNazionale(regione) {
  const key = String(regione || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  switch (key) {
    case "abruzzo":
      return {
        prodotti_deco_tipici: [
          "Ceppe Civitellesi (pasta al ferretto)",
          "Porchetta Italica di Campli DE.C.O.",
          "Arrosticini Abruzzesi",
        ],
        vini_autoctoni_regionali: [
          "Montepulciano d'Abruzzo Colline Teramane DOCG",
          "Cerasuolo d'Abruzzo DOC",
          "Trebbiano",
        ],
        eventi_ricorrenti_principali: [
          "Sagra delle Ceppe (Agosto)",
          "Mostra Mercato della Porchetta Italica",
        ],
      };
    case "campania":
      return {
        prodotti_deco_tipici: [
          "Mozzarella di Bufala Campana DOP",
          "Pizza Napoletana STG",
          "Limone Costa d'Amalfi IGP",
        ],
        vini_autoctoni_regionali: [
          "Fiano di Avellino DOCG",
          "Taurasi DOCG",
          "Greco di Tufo",
        ],
        eventi_ricorrenti_principali: [
          "Festa del Limone",
          "Sagre dei Prodotti Tipici della Penisola",
        ],
      };
    case "toscana":
      return {
        prodotti_deco_tipici: [
          "Bistecca alla Fiorentina",
          "Pane Toscano DOP (sciapo)",
          "Pici di Siena DE.C.O.",
        ],
        vini_autoctoni_regionali: [
          "Chianti Classico DOCG",
          "Brunello di Montalcino",
          "Vernaccia di San Gimignano",
        ],
        eventi_ricorrenti_principali: [
          "Calici di Stelle",
          "Sagra del Tordo e del Cinghiale",
        ],
      };
    case "puglia":
      return {
        prodotti_deco_tipici: [
          "Orecchiette alle Cime di Rapa",
          "Pane di Altamura DOP",
          "Focaccia Barese DE.C.O.",
        ],
        vini_autoctoni_regionali: [
          "Primitivo di Manduria DOCG",
          "Negroamaro",
          "Salice Salentino",
        ],
        eventi_ricorrenti_principali: [
          "Sagra della Taranta ed Enogastronomia",
          "Festa dell'Olio Nuovo",
        ],
      };
    case "lazio":
      return {
        prodotti_deco_tipici: [
          "Pecorino Romano DOP",
          "Guanciale di Amatrice IGP",
          "Spaghetti alla Carbonara / Amatriciana",
        ],
        vini_autoctoni_regionali: [
          "Frascati Superiore DOCG",
          "Cesanese del Piglio",
          "Est! Est!! Est!!! di Montefiascone",
        ],
        eventi_ricorrenti_principali: [
          "Sagra degli Spaghetti all'Amatriciana",
          "Festa dell'Uva e del Vino",
        ],
      };
    case "marche":
      return {
        prodotti_deco_tipici: [
          "Oliva Ascolana del Piceno DOP",
          "Vincisgrassi",
          "Ciauscolo IGP",
        ],
        vini_autoctoni_regionali: [
          "Verdicchio dei Castelli di Jesi",
          "Falerio dei Colli Ascolani",
          "Rosso Piceno",
        ],
        eventi_ricorrenti_principali: [
          "Feste dell'oliva ascolana",
          "Sagre dei prodotti tipici piceni",
        ],
      };
    default:
      return {
        prodotti_deco_tipici: [
          "Prodotti dell'Artigianato Locale",
          "Specialità Gastronomiche della Tradizione",
        ],
        vini_autoctoni_regionali: ["Vini DOC/DOCG del Territorio"],
        eventi_ricorrenti_principali: [
          "Feste Patronali e Mercati della Terra",
        ],
      };
  }
}

/** Sigle ISO 3166-2 IT → nome per `generaEnogastronomiaNazionale` (solo regioni già in seed). */
export const SIGLA_REGIONE_TO_NOME = {
  ABR: "Abruzzo",
  CAM: "Campania",
  TOS: "Toscana",
  PUG: "Puglia",
  LAZ: "Lazio",
  MAR: "Marche",
};

/** Cache gusto per sigla — stesso contenuto di `generaEnogastronomiaNazionale`. */
export const ECO_DB = {
  ABR: generaEnogastronomiaNazionale("Abruzzo"),
  CAM: generaEnogastronomiaNazionale("Campania"),
  TOS: generaEnogastronomiaNazionale("Toscana"),
  PUG: generaEnogastronomiaNazionale("Puglia"),
  LAZ: generaEnogastronomiaNazionale("Lazio"),
  MAR: generaEnogastronomiaNazionale("Marche"),
};

/** Gusto regionale da sigla (`ABR`) o nome; non inventa prodotti. */
export function getGustoRegionale(siglaRegione) {
  const raw = String(siglaRegione || "").trim();
  if (!raw) return generaEnogastronomiaNazionale("");
  const sigla = raw.toUpperCase().replace(/^IT-/, "");
  if (ECO_DB[sigla]) return ECO_DB[sigla];
  const fromSigla = SIGLA_REGIONE_TO_NOME[sigla];
  if (fromSigla) return generaEnogastronomiaNazionale(fromSigla);
  return generaEnogastronomiaNazionale(raw);
}

export const tradizioniCivitella = {
  prodotti_deco_tipici: [
    "Ceppe Civitellesi (pasta al ferretto)",
    "Filetto alla Borbonica",
  ],
  vini_autoctoni_regionali: [
    "Montepulciano d'Abruzzo Colline Teramane DOCG",
    "Cerasuolo d'Abruzzo DOC",
  ],
  eventi_ricorrenti_principali: [
    "Apertura Monumentale Fortezza",
    "Sagra delle Ceppe (Agosto)",
    "Rievocazioni storiche borboniche",
  ],
};

export const civiciCivitella = generaCiviciDefault("civitella-del-tronto");
export const trasportiCivitella = generaTrasportiDefault("civitella-del-tronto");

/** Numeri di pubblica utilità — comuni Abruzzo / provincia Teramo (Ruzzo + E-Distribuzione). */
export const utilitaTeramoDefault = {
  polizia_locale_telefono: "+39 0861 91321 (Comando Territoriale)",
  pronto_intervento_guasti: {
    servizio_idrico: "800.066.033 (Ruzzo Reti - Pronto Intervento)",
    servizio_elettrico: "803.500 (E-Distribuzione Segnalazione Guasti)",
  },
  protezione_civile_hub: "Gruppo Volontari Protezione Civile Gran Sasso-Laga",
  meteo_allerta_tracking: true,
};

/**
 * Castel Trosino / Ascoli Piceno — senza numeri inventati.
 * CIIP non presente in archivio progetto → etichetta da verificare.
 */
export const utilitaAscoliDefault = {
  polizia_locale_telefono: "Comune di Ascoli Piceno — Polizia Municipale",
  pronto_intervento_guasti: {
    servizio_idrico: "Da verificare con Comune (CIIP pronto intervento)",
    servizio_elettrico: "803.500 (E-Distribuzione Segnalazione Guasti)",
  },
  protezione_civile_hub: "Protezione Civile — Comune di Ascoli Piceno",
  meteo_allerta_tracking: true,
};

export const curatelaCivitella = {
  curatore_attivo: true,
  tipologia_curatore: "Pro Loco",
  ente_certificatore: "Comune di Civitella del Tronto",
  account_istituzionale_verificato: true,
};

/**
 * Unicode Regional Indicator Symbols da codice ISO alpha-2 (algoritmo 127397).
 * Fallback bandiera bianca se il codice non è valido.
 */
export function ottieniBandieraNazionale(countryCode) {
  const cc = String(countryCode || "")
    .trim()
    .toUpperCase();
  if (cc.length !== 2 || !/^[A-Z]{2}$/.test(cc)) return "🏳️";
  return String.fromCodePoint(
    127397 + cc.charCodeAt(0),
    127397 + cc.charCodeAt(1),
  );
}

/** Nazioni note nel seed territorio / CSV → ISO 3166-1 alpha-2. */
const NAZIONE_TO_ISO = {
  austria: "AT",
  polonia: "PL",
  croazia: "HR",
  giappone: "JP",
  malta: "MT",
  francia: "FR",
  "stati uniti": "US",
  usa: "US",
  germania: "DE",
  spagna: "ES",
  portogallo: "PT",
  grecia: "GR",
  slovenia: "SI",
  svizzera: "CH",
  belgio: "BE",
  olanda: "NL",
  "paesi bassi": "NL",
  "regno unito": "GB",
  uk: "GB",
  inghilterra: "GB",
  irlanda: "IE",
  romania: "RO",
  ungaria: "HU",
  "repubblica ceca": "CZ",
  slovacchia: "SK",
  serbia: "RS",
  albania: "AL",
  bosnia: "BA",
  "bosnia ed erzegovina": "BA",
  montenegro: "ME",
  bulgaria: "BG",
  turchia: "TR",
  cina: "CN",
  brasile: "BR",
  argentina: "AR",
  canada: "CA",
  australia: "AU",
  italia: "IT",
};

export function nazioneToIsoCode(nazione) {
  const key = String(nazione || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (/^[a-z]{2}$/.test(key)) return key.toUpperCase();
  return NAZIONE_TO_ISO[key] || "";
}

function mapTipologiaPattoToScambio(tipologia) {
  const t = String(tipologia || "").toLowerCase();
  if (t.includes("eno") || t.includes("gastronom")) return "ENOGASTRONOMICO";
  if (
    t.includes("istituz") ||
    t.includes("comunale") ||
    t === "gemellaggio" ||
    t.includes("esclusivo")
  ) {
    return "ISTITUZIONALE";
  }
  return "CULTURALE";
}

/**
 * Mappa seed territorio (`gemellaggi_attivi`) → schede bandiere.
 * Salta righe senza città o senza codice ISO. Non inventa anni.
 */
export function mapTerritorioGemellaggiToMondiale(rows, comuneSlug) {
  const slug = String(comuneSlug || "borgo").trim().toLowerCase() || "borgo";
  const out = [];
  (Array.isArray(rows) ? rows : []).forEach((row, i) => {
    const city = String(row?.comune_gemellato || "").trim();
    const code = nazioneToIsoCode(row?.nazione || "");
    if (!city || !code) return;
    const item = {
      id_gemellaggio: `${slug}-${code}-${i}`,
      twin_country_code: code,
      twin_city_name: city,
      tipologia_scambio: mapTipologiaPattoToScambio(row?.tipologia_patto),
    };
    if (row?.anno_inizio != null && Number.isFinite(Number(row.anno_inizio))) {
      item.anno_inizio_paccordo = Number(row.anno_inizio);
    }
    const reason = String(row?.motivazione || row?.network_reason || row?.perche || "").trim();
    if (reason) item.network_reason = reason;
    out.push(item);
  });
  return out;
}

/**
 * Mappa `/api/gemellaggi` → schede bandiere (piattaforma, non AICCRE).
 */
export function mapApiGemellaggiToMondiale(rows) {
  const out = [];
  (Array.isArray(rows) ? rows : []).forEach((row, i) => {
    // Record marcati "da verificare" non vengono mostrati al pubblico
    // finché la fonte ufficiale non è stata confermata.
    if (row?.da_verificare === true) return;
    const city = String(row?.twin_name || "").trim();
    let code = String(row?.twin_country_code || "")
      .trim()
      .toUpperCase();
    if (!/^[A-Z]{2}$/.test(code)) {
      code = nazioneToIsoCode(String(row?.twin_country || ""));
    }
    if (!city || !/^[A-Z]{2}$/.test(code)) return;
    const item = {
      id_gemellaggio: String(row?.id || `${code}-${i}`),
      twin_country_code: code,
      twin_city_name: city,
      tipologia_scambio: "ISTITUZIONALE",
    };
    const countryName = String(row?.twin_country || "").trim();
    if (countryName) item.twin_country = countryName;
    const fonte = String(row?.fonte || row?.source || "").trim();
    if (fonte) item.fonte = fonte;
    const since = row?.since != null ? String(row.since) : "";
    const yearMatch = since.match(/(19|20)\d{2}/);
    if (yearMatch) item.anno_inizio_paccordo = Number(yearMatch[0]);
    const site = String(row?.website || row?.url || "").trim();
    if (/^https?:\/\//i.test(site)) item.website_url = site;
    const reason = String(row?.description || row?.network_reason || row?.motivo || "").trim();
    if (reason) item.network_reason = reason;
    out.push(item);
  });
  return out;
}

/**
 * Mappa riga seed CSV → scheda bandiere.
 * Badge UI: «Archivio gemellaggi» / «Seed locale» — mai «Certificato AICCRE» senza evidenza.
 */
export function mapSeedCsvRowToMondiale(row, index = 0) {
  const city = String(row?.citta_estera || "").trim();
  const code = nazioneToIsoCode(
    String(row?.nazione_estera || row?.stato_estero || "").trim(),
  );
  if (!city || !code) return null;
  const comune = String(row?.comune_italiano || "seed")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");
  const item = {
    id_gemellaggio: `seed-${comune}-${code}-${index}`,
    twin_country_code: code,
    twin_city_name: city,
    tipologia_scambio: mapTipologiaPattoToScambio(row?.tipo_accordo),
  };
  if (row?.anno_stipula != null && String(row.anno_stipula).trim() !== "") {
    const y = Number(row.anno_stipula);
    if (Number.isFinite(y)) item.anno_inizio_paccordo = y;
  }
  return item;
}

/** Gemellaggio monumentale 1989 (fonte Wikipedia Fortezza). Avetrana non verificato → omesso. */
export const gemellaggiCivitella = [
  {
    comune_gemellato:
      "Salisburgo — fortezze Hohensalzburg, Mauterndorf e Werfen",
    nazione: "Austria",
    anno_inizio: 1989,
    tipologia_patto: "gemellaggio_monumentale",
    focus_scambio_culturale: [
      "Gemellaggio tra piazzeforti storiche",
      "Patrimonio militare e architettonico",
      "Valorizzazione turistico-culturale",
    ],
  },
];

/** Fonte: MoscianoGemellaggiInternazionali.jsx / bundle Mosciano. */
export const gemellaggiMosciano = [
  {
    comune_gemellato: "Płońsk",
    nazione: "Polonia",
    tipologia_patto: "gemellaggio_comunale",
    focus_scambio_culturale: [
      "Scambi sociali e scolaresche",
      "Progetti di sviluppo comunitario",
    ],
  },
  {
    comune_gemellato: "Rijeka (Fiume)",
    nazione: "Croazia",
    tipologia_patto: "protocollo_intesa",
    focus_scambio_culturale: [
      "Scambi culturali, artistici e istituzionali",
    ],
  },
  {
    comune_gemellato: "Graz",
    nazione: "Austria",
    /** Fonte documentata: MoscianoComuniAmiciGraz / maggio 2013 */
    anno_inizio: 2013,
    tipologia_patto: "protocollo_intesa",
    focus_scambio_culturale: [
      "Cooperazione economica e artigianale",
      "Agenzia di sviluppo regionale di Graz",
    ],
  },
];

function slugKeys(slug, aliases) {
  const out = new Set();
  const add = (s) => {
    const v = (s || "").trim().toLowerCase();
    if (v) out.add(v);
  };
  add(slug);
  (aliases || []).forEach(add);
  return out;
}

function findHospitality(slug, aliases) {
  const keys = slugKeys(slug, aliases);
  const blocks = ospitalitaData.strutture_ricettive_ristorazione || [];
  return blocks.find((h) => {
    const hKeys = slugKeys(h.slug_frazione, h.slug_frazione_aliases);
    for (const k of keys) {
      if (hKeys.has(k)) return true;
    }
    return false;
  });
}

function extractTradizioni(ar, fallback) {
  const specific = ar.tradizioni_cultura_specifiche || ar.tradizioni_cultura;
  if (
    specific &&
    Array.isArray(specific.prodotti_deco_tipici) &&
    Array.isArray(specific.eventi_ricorrenti_principali)
  ) {
    const vini = Array.isArray(specific.vini_autoctoni_regionali)
      ? specific.vini_autoctoni_regionali
      : fallback.vini_autoctoni_regionali;
    return {
      prodotti_deco_tipici: specific.prodotti_deco_tipici,
      eventi_ricorrenti_principali: specific.eventi_ricorrenti_principali,
      ...(vini && vini.length ? { vini_autoctoni_regionali: vini } : {}),
    };
  }
  return fallback;
}

function mergeScheda(ar, overrides) {
  const hosp = findHospitality(ar.slug_frazione, ar.slug_frazione_aliases);
  const sanita = (overrides && overrides.servizi_sanitari) || sanitaCivitella;
  const costa = (overrides && overrides.collegamenti_costa) || costaCivitella;
  const civici = (overrides && overrides.servizi_civici) || civiciCivitella;
  const trasporti = (overrides && overrides.trasporti_locali) || trasportiCivitella;
  const utilita =
    (overrides && overrides.utilita_locali) || utilitaTeramoDefault;
  const tradizioniFallback =
    (overrides && overrides.tradizioni_fallback) ||
    generaEnogastronomiaNazionale(
      (overrides && overrides.regione) || "Abruzzo"
    );
  const tradizioni = extractTradizioni(ar, tradizioniFallback);
  const {
    tradizioni_cultura_specifiche: _tSpec,
    tradizioni_cultura: _tCult,
    canali_attivi: canaliRaw,
    ...rest
  } = ar;
  const puntoAr = rest.punto_ar || {};
  const canali_attivi = resolveCanaliAttivi(canaliRaw, puntoAr.macro_area);
  return {
    ...rest,
    canali_attivi,
    features_piattaforma: features6amicoDefault,
    servizi_sanitari: sanita,
    collegamenti_costa: costa,
    servizi_civici: civici,
    trasporti_locali: trasporti,
    utilita_locali: utilita,
    tradizioni_cultura: tradizioni,
    ristoranti: (hosp && hosp.ristoranti) || [],
    alloggi: (hosp && hosp.alloggi) || [],
  };
}

const frazioniCivitellaUnite = [
  mergeScheda(abbaziaData, {
    servizi_sanitari: sanitaCivitella,
    collegamenti_costa: costaCivitella,
    servizi_civici: civiciCivitella,
    trasporti_locali: trasportiCivitella,
    tradizioni_fallback: tradizioniCivitella,
    regione: "Abruzzo",
  }),
  mergeScheda(goleData, {
    servizi_sanitari: sanitaCivitella,
    collegamenti_costa: costaCivitella,
    servizi_civici: civiciCivitella,
    trasporti_locali: trasportiCivitella,
    tradizioni_fallback: tradizioniCivitella,
    regione: "Abruzzo",
  }),
  mergeScheda(fortezzaData, {
    servizi_sanitari: sanitaCivitella,
    collegamenti_costa: costaCivitella,
    servizi_civici: civiciCivitella,
    trasporti_locali: trasportiCivitella,
    tradizioni_fallback: tradizioniCivitella,
    regione: "Abruzzo",
  }),
];

const frazioneCampli = mergeScheda(campliData, {
  servizi_sanitari: generaSanitaDefault("Teramo"),
  collegamenti_costa: generaCostaTeramanaDefault(24, 25, [
    "Superstrada Teramo-Mare",
  ]),
  servizi_civici: generaCiviciDefault("campli"),
  trasporti_locali: generaTrasportiDefault("campli"),
  regione: "Abruzzo",
});

const frazioneCrognaleto = mergeScheda(crognaletoData, {
  servizi_sanitari: generaSanitaDefault("Teramo"),
  collegamenti_costa: generaCostaTeramanaDefault(52, 55, [
    "SS81",
    "Superstrada Teramo-Mare",
  ]),
  servizi_civici: generaCiviciDefault("crognaleto"),
  trasporti_locali: generaTrasportiDefault("crognaleto"),
  regione: "Abruzzo",
});

const frazioneTorricella = mergeScheda(torricellaData, {
  servizi_sanitari: generaSanitaDefault("Teramo"),
  collegamenti_costa: generaCostaTeramanaDefault(30, 32, [
    "SS81",
    "Superstrada Teramo-Mare",
  ]),
  servizi_civici: generaCiviciDefault("torricella-sicura"),
  trasporti_locali: generaTrasportiDefault("torricella-sicura"),
  regione: "Abruzzo",
});

const frazioneCastelTrosino = mergeScheda(castelTrosinoData, {
  servizi_sanitari: generaSanitaDefault("Ascoli Piceno"),
  collegamenti_costa: generaCostaTeramanaDefault(
    28,
    30,
    ["Raccordo Autostradale Ascoli-Mare"],
    DISTANZE_COSTA_PICENA
  ),
  servizi_civici: generaCiviciDefault("ascoli-piceno"),
  trasporti_locali: generaTrasportiDefault("ascoli-piceno"),
  utilita_locali: utilitaAscoliDefault,
  regione: "Marche",
});

const frazioneMosciano = mergeScheda(moscianoData, {
  servizi_sanitari: generaSanitaDefault("Teramo"),
  collegamenti_costa: generaCostaTeramanaDefault(9, 12, [
    "SP262",
    "Autostrada A14 Casello Giulianova-Mosciano",
  ]),
  servizi_civici: generaCiviciDefault("mosciano-sant-angelo"),
  trasporti_locali: generaTrasportiDefault("mosciano-sant-angelo"),
  regione: "Abruzzo",
});

const frazioneCastiglione = mergeScheda(castiglioneData, {
  servizi_sanitari: generaSanitaDefault("Teramo"),
  collegamenti_costa: generaCostaTeramanaDefault(32, 35, [
    "SP31 della Val Fino",
    "SS16 Adriatica / Innesto A14 Pineto",
  ]),
  servizi_civici: generaCiviciDefault("castiglione-messer-raimondo"),
  trasporti_locali: generaTrasportiDefault("castiglione-messer-raimondo"),
  regione: "Abruzzo",
});

export const DATABASE_TERRITORIO_DEFAULT = [
  {
    comune_id: "civitella-del-tronto",
    piattaforma_riferimento: "6amico.com",
    regione: "Abruzzo",
    provincia: "Teramo",
    classificazione_nodo: "Nodo Attivo",
    punti_ar_totali: frazioniCivitellaUnite.length,
    curatela_istituzionale: curatelaCivitella,
    gemellaggi_attivi: gemellaggiCivitella,
    frazioni: frazioniCivitellaUnite,
  },
  {
    comune_id: "campli",
    piattaforma_riferimento: "6amico.com",
    regione: "Abruzzo",
    provincia: "Teramo",
    classificazione_nodo: "Nodo Attivo",
    punti_ar_totali: 1,
    curatela_istituzionale: {
      curatore_attivo: true,
      tipologia_curatore: "Sindaco",
      ente_certificatore: "Comune di Campli",
      account_istituzionale_verificato: true,
    },
    gemellaggi_attivi: [],
    frazioni: [frazioneCampli],
  },
  {
    comune_id: "crognaleto",
    piattaforma_riferimento: "6amico.com",
    regione: "Abruzzo",
    provincia: "Teramo",
    classificazione_nodo: "Nodo Attivo",
    punti_ar_totali: 1,
    curatela_istituzionale: {
      curatore_attivo: false,
      tipologia_curatore: "Nessuno",
      account_istituzionale_verificato: false,
    },
    gemellaggi_attivi: [],
    frazioni: [frazioneCrognaleto],
  },
  {
    comune_id: "torricella-sicura",
    piattaforma_riferimento: "6amico.com",
    regione: "Abruzzo",
    provincia: "Teramo",
    classificazione_nodo: "Nodo Attivo",
    punti_ar_totali: 1,
    curatela_istituzionale: {
      curatore_attivo: true,
      tipologia_curatore: "Pro Loco",
      ente_certificatore: "Comune di Torricella Sicura",
      account_istituzionale_verificato: true,
    },
    gemellaggi_attivi: [],
    frazioni: [frazioneTorricella],
  },
  {
    comune_id: "ascoli-piceno",
    piattaforma_riferimento: "6amico.com",
    regione: "Marche",
    provincia: "Ascoli Piceno",
    classificazione_nodo: "Nodo Attivo",
    punti_ar_totali: 1,
    curatela_istituzionale: {
      curatore_attivo: false,
      tipologia_curatore: "Nessuno",
      account_istituzionale_verificato: false,
    },
    gemellaggi_attivi: [],
    frazioni: [frazioneCastelTrosino],
  },
  {
    comune_id: "mosciano-sant-angelo",
    piattaforma_riferimento: "6amico.com",
    regione: "Abruzzo",
    provincia: "Teramo",
    classificazione_nodo: "Nodo Attivo",
    punti_ar_totali: 1,
    curatela_istituzionale: {
      curatore_attivo: true,
      tipologia_curatore: "Sindaco",
      ente_certificatore: "Comune di Mosciano Sant'Angelo",
      account_istituzionale_verificato: true,
    },
    gemellaggi_attivi: gemellaggiMosciano,
    frazioni: [frazioneMosciano],
  },
  {
    comune_id: "castiglione-messer-raimondo",
    piattaforma_riferimento: "6amico.com",
    regione: "Abruzzo",
    provincia: "Teramo",
    classificazione_nodo: "Nodo Attivo",
    punti_ar_totali: 1,
    curatela_istituzionale: {
      curatore_attivo: true,
      tipologia_curatore: "Pro Loco",
      ente_certificatore: "Comune di Castiglione Messer Raimondo",
      account_istituzionale_verificato: true,
    },
    gemellaggi_attivi: [],
    frazioni: [frazioneCastiglione],
  },
];

export function getComuneById(comuneId) {
  const key = (comuneId || "").trim().toLowerCase();
  if (!key) return undefined;
  return DATABASE_TERRITORIO_DEFAULT.find((c) => c.comune_id.toLowerCase() === key);
}

export function getFrazioneBySlug(slug) {
  const key = (slug || "").trim().toLowerCase();
  if (!key) return undefined;
  for (const comune of DATABASE_TERRITORIO_DEFAULT) {
    const trovata = comune.frazioni.find((f) => {
      if ((f.slug_frazione || "").toLowerCase() === key) return true;
      return (f.slug_frazione_aliases || []).some((a) => (a || "").toLowerCase() === key);
    });
    if (trovata) return trovata;
  }
  return undefined;
}

export function getFrazioniByComune(comuneId) {
  const comune = DATABASE_TERRITORIO_DEFAULT.find((c) => c.comune_id === comuneId);
  return comune ? comune.frazioni : [];
}

export function getPuntoArByPoiId(poiId) {
  const key = (poiId || "").trim().toLowerCase();
  if (!key) return undefined;
  for (const comune of DATABASE_TERRITORIO_DEFAULT) {
    for (const f of comune.frazioni) {
      const ar = f.punto_ar;
      if (!ar) continue;
      if ((ar.poi_id || "").toLowerCase() === key) return ar;
      if ((ar.monument_slug || "").toLowerCase() === key) return ar;
    }
  }
  return undefined;
}

/**
 * Resolve display copy for a PuntoAR in the requested language.
 * Prefers lingue[lang], then localizzato[lang], then titolo / descrizione_storica.
 */
export function resolvePuntoArLocale(punto_ar, lang = "it", specialitaFallback = []) {
  const code = String(lang || "it").split("-")[0].toLowerCase();
  const fallbackTitolo = String((punto_ar && punto_ar.titolo) || "").trim();
  const fallbackDesc = String((punto_ar && punto_ar.descrizione_storica) || "").trim();
  const fallbackSpecialita = Array.isArray(specialitaFallback)
    ? specialitaFallback.filter(Boolean)
    : [];

  const fromLingue =
    punto_ar && punto_ar.lingue && punto_ar.lingue[code] ? punto_ar.lingue[code] : null;
  if (fromLingue && (fromLingue.titolo || fromLingue.descrizione_storica)) {
    const titolo = String(fromLingue.titolo || "").trim() || fallbackTitolo;
    const descrizione_storica =
      String(fromLingue.descrizione_storica || "").trim() || fallbackDesc;
    const specialita_culinarie =
      Array.isArray(fromLingue.specialita_culinarie) &&
      fromLingue.specialita_culinarie.length > 0
        ? fromLingue.specialita_culinarie
        : fallbackSpecialita;
    return {
      titolo,
      descrizione_storica,
      descrizione: descrizione_storica,
      specialita_culinarie,
    };
  }

  const fromLocalizzato =
    punto_ar && punto_ar.localizzato && punto_ar.localizzato[code]
      ? punto_ar.localizzato[code]
      : null;
  if (fromLocalizzato && (fromLocalizzato.titolo || fromLocalizzato.descrizione)) {
    const titolo = String(fromLocalizzato.titolo || "").trim() || fallbackTitolo;
    const descrizione_storica =
      String(fromLocalizzato.descrizione || "").trim() || fallbackDesc;
    return {
      titolo,
      descrizione_storica,
      descrizione: descrizione_storica,
      specialita_culinarie: fallbackSpecialita,
    };
  }

  return {
    titolo: fallbackTitolo,
    descrizione_storica: fallbackDesc,
    descrizione: fallbackDesc,
    specialita_culinarie: fallbackSpecialita,
  };
}

function normalizeTerritorioId(id) {
  return String(id || "")
    .trim()
    .toLowerCase();
}

/**
 * Nodi nazionali unificati (TE / AQ / Umbria).
 * Foto solo `/hero/` o `/images/` — mai `/assets/nodi/*`.
 */
export const DATABASE_TERRITORIO_REALE = [
  // TE frazioni distinte
  {
    slug: "pietracamela__intermesoli",
    nome: "Intermesoli",
    comprensorio: "Pietracamela (TE) • Montagna",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Intermesoli, a 770 m s.l.m., vanta un'antica origine e una storia indissolubilmente legata ai boschi e al commercio storico della lana d'Appennino.",
    urlFotoCertificata: "/hero/pietracamela.jpg",
    href: "/frazione/pietracamela__intermesoli",
  },
  {
    slug: "pietracamela__prati-di-tivo",
    nome: "Prati di Tivo",
    comprensorio: "Pietracamela (TE) • Outdoor",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Rinomata frazione montana del comune di Pietracamela situata a circa 1.450 metri di altitudine ai piedi del Gran Sasso d'Italia, culla dell'alpinismo e dello sci.",
    urlFotoCertificata: "/hero/pietracamela-bosco.jpg",
    href: "/frazione/pietracamela__prati-di-tivo",
  },
  // TE pilota comuni
  {
    slug: "campli",
    nome: "Campli",
    comprensorio: "Teramo (TE) • Pilota",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Scala Santa, palazzi storici e tradizioni popolari nel cuore culturale della provincia teramana.",
    urlFotoCertificata: "/hero/campli.png",
    href: "/comune/campli",
  },
  {
    slug: "crognaleto",
    nome: "Crognaleto",
    comprensorio: "Teramo (TE) • Montagna",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Borghi montani, faggete e percorsi verso il Gran Sasso custodiscono memoria, natura e comunità.",
    urlFotoCertificata: "/hero/crognaleto.jpg",
    href: "/comune/crognaleto",
  },
  {
    slug: "pietracamela",
    nome: "Pietracamela",
    comprensorio: "Teramo (TE) • Gran Sasso",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Ai piedi del Corno Piccolo, pietra, alpinismo e paesaggio identitario nel cuore del Gran Sasso.",
    urlFotoCertificata: "/hero/pietracamela.jpg",
    href: "/comune/pietracamela",
  },
  {
    slug: "mosciano-sant-angelo",
    nome: "Mosciano Sant'Angelo",
    comprensorio: "Teramo (TE) • Collina",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Tra costa e colline, Mosciano connette ospitalità, imprese locali e percorsi del territorio teramano.",
    urlFotoCertificata: "/hero/mosciano-sant-angelo.jpg",
    href: "/comune/mosciano-sant-angelo",
  },
  {
    slug: "castiglione-messer-raimondo",
    nome: "Castiglione Messer Raimondo",
    comprensorio: "Teramo (TE) • Val Fino",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Un'affascinante porta gentile tra le colline della Val Fino, ricca di storia e tradizioni rurali.",
    urlFotoCertificata: "/hero/castiglione-messer-raimondo.jpg",
    href: "/comune/castiglione-messer-raimondo",
  },
  {
    slug: "castelli",
    nome: "Castelli",
    comprensorio: "Teramo (TE) • Ceramica",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "La ceramica, le botteghe e il paesaggio ai piedi del Gran Sasso definiscono un laboratorio diffuso.",
    urlFotoCertificata: "/hero/castelli-borgo.jpg",
    href: "/comune/castelli",
  },
  {
    slug: "civitella-del-tronto",
    nome: "Civitella del Tronto",
    comprensorio: "Teramo (TE) • Fortezza",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "La fortezza borbonica domina il borgo e apre una rotta tra storia militare, artigianato e panorami.",
    urlFotoCertificata: "/hero/civitella-del-tronto.jpg",
    href: "/comune/civitella-del-tronto",
  },
  {
    slug: "torricella-sicura",
    nome: "Torricella Sicura",
    comprensorio: "Teramo (TE) • Collina",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Tra Gran Sasso e Monti della Laga: frazioni storiche, memoria sismica e tradizioni enogastronomiche.",
    urlFotoCertificata: "/hero/torricella-sicura.jpg",
    href: "/comune/torricella-sicura",
  },
  {
    slug: "montorio-al-vomano",
    nome: "Montorio al Vomano",
    comprensorio: "Teramo (TE) • Valle del Vomano",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Valle del Vomano, tradizioni enogastronomiche e la storica Pizza Dolce — memoria viva accanto a Campli.",
    urlFotoCertificata: "/hero/montorio-al-vomano.jpg",
    href: "/comune/montorio-al-vomano",
  },
  {
    slug: "rocca-santa-maria",
    nome: "Rocca Santa Maria",
    comprensorio: "Teramo (TE) • Laga",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Borgo montano tra Laga e Vomano: frazioni sparse, natura e radici contadine nel cuore dell'Appennino teramano.",
    urlFotoCertificata: "/images/rocca-santa-maria/cascata-morricana-cartello.jpg",
    href: "/comune/rocca-santa-maria",
  },
  // AQ Gran Sasso
  {
    slug: "paganica",
    nome: "Paganica",
    comprensorio: "L'Aquila (AQ) • Valle del Raiale",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Frazione dell'Aquila sul Raiale: ospita il suggestivo santuario rupestre della Madonna d'Appari incastonato nella roccia viva, coltivazioni di zafferano DOP e sentieri storici.",
    urlFotoCertificata: "/hero/paganica.jpg",
    href: "/comune/paganica",
  },
  {
    slug: "assergi",
    nome: "Assergi",
    comprensorio: "L'Aquila (AQ) • Gran Sasso",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Antico borgo fortificato ai piedi della funivia del Gran Sasso, sede istituzionale del Parco Nazionale e dei Laboratori Nazionali di Fisica Nucleare (INFN).",
    urlFotoCertificata: "/hero/assergi.jpg",
    href: "/comune/assergi",
  },
  {
    slug: "campo-imperatore",
    nome: "Campo Imperatore",
    comprensorio: "L'Aquila (AQ) • Altopiano",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Il Piccolo Tibet del Gran Sasso: funivia, set di Trinità, sentieri e pascoli d'altura.",
    urlFotoCertificata: "/hero/campo-imperatore.png",
    href: "/comune/campo-imperatore",
  },
  {
    slug: "calascio",
    nome: "Calascio",
    comprensorio: "L'Aquila (AQ) • Baronia",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Borgo della Baronia ai piedi di Rocca Calascio: chiesa ottagonale di Santa Maria della Pietà e sentieri della transumanza.",
    urlFotoCertificata: "/hero/calascio.png",
    href: "/comune/calascio",
  },
  {
    slug: "castel-del-monte",
    nome: "Castel del Monte",
    comprensorio: "L'Aquila (AQ) • Baronia",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Capitale dei pastori e porta orientale dell'altopiano: Canyon dello Scoppaturo e Cammino del Gran Sasso.",
    urlFotoCertificata: "/hero/castel-del-monte.png",
    href: "/comune/castel-del-monte",
  },
  {
    slug: "santo-stefano-di-sessanio",
    nome: "Santo Stefano di Sessanio",
    comprensorio: "L'Aquila (AQ) • Baronia",
    regioneNazione: "Abruzzo",
    descrizioneAutentica:
      "Borgo mediceo della Baronia, tra Campo Imperatore e Rocca Calascio.",
    urlFotoCertificata: "/hero/santo-stefano-di-sessanio.jpg",
    href: "/comune/santo-stefano-di-sessanio",
  },
  // Umbria gemellaggi
  {
    slug: "assisi",
    nome: "Assisi",
    comprensorio: "Assisi (PG) • Rete Gemellaggi",
    regioneNazione: "Umbria",
    descrizioneAutentica:
      "Città serafica patrimonio mondiale UNESCO, centro universale di pace e gemellaggio culturale con il borgo delle ceramiche di Castelli.",
    urlFotoCertificata:
      "/images/assisi/basilica-san-francesco/esterni/IMG20260117160024_BURST000_COVER.jpg",
    href: "/comune/assisi",
  },
];

const TERRITORIO_REALE_ALIASES = {
  intermesoli: "pietracamela__intermesoli",
  "prati-di-tivo": "pietracamela__prati-di-tivo",
  pratiditivo: "pietracamela__prati-di-tivo",
  montorio: "montorio-al-vomano",
};

export function schedaLocalitaUnificata(slug) {
  const id = normalizeTerritorioId(slug);
  if (!id) return undefined;
  const canonical = TERRITORIO_REALE_ALIASES[id] || id;
  return DATABASE_TERRITORIO_REALE.find((s) => s.slug === canonical || s.slug === id);
}

export function fotoDaTerritorioReale(slug) {
  const scheda = schedaLocalitaUnificata(slug);
  if (scheda && scheda.urlFotoCertificata) return scheda.urlFotoCertificata;
  return fotoCopertinaDaHeroMap(slug);
}

/** Copertina da HERO_BY_SLUG o DATABASE_TERRITORIO_REALE — mai path CDN inventati. */
export function fotoCopertinaDaHeroMap(comuneId) {
  const id = normalizeTerritorioId(comuneId);
  if (!id) return "";
  const canonical = TERRITORIO_REALE_ALIASES[id] || id;
  const fromReale = DATABASE_TERRITORIO_REALE.find(
    (s) => s.slug === canonical || s.slug === id
  );
  if (fromReale && fromReale.urlFotoCertificata) return fromReale.urlFotoCertificata;
  if (HERO_BY_SLUG[id]) return HERO_BY_SLUG[id];
  if (HERO_BY_SLUG[canonical]) return HERO_BY_SLUG[canonical];
  const sep = id.indexOf("__");
  if (sep > 0) {
    const base = id.slice(0, sep);
    if (HERO_BY_SLUG[base]) return HERO_BY_SLUG[base];
  }
  return "";
}

/**
 * Copertine griglia borghi allineati — solo HERO_BY_SLUG.
 * Nessun fallback `https://6amico.com…` né `/assets/nodi/*`.
 */
/**
 * Copertina ufficiale Montorio al Vomano (e fallback sicuro per altri id).
 * Montorio → `/hero/montorio-al-vomano.jpg` via HERO_BY_SLUG.
 * Altri → `fotoCopertinaDaHeroMap` (mai `/assets/nodi/*` né CDN inventati).
 */
export function risolviFotoMontorioUfficiale(comuneId) {
  const id = normalizeTerritorioId(comuneId);
  if (!id) return "";
  if (id === "montorio-al-vomano" || id === "montorio") {
    return (
      HERO_BY_SLUG["montorio-al-vomano"] ||
      HERO_BY_SLUG.montorio ||
      "/hero/montorio-al-vomano.jpg"
    );
  }
  return fotoCopertinaDaHeroMap(id);
}

/**
 * Copertine griglia borghi allineati — solo HERO_BY_SLUG.
 * Nessun fallback `https://6amico.com…` né `/assets/nodi/*`.
 */
export function risolviFotoBorgoAllineato(comuneId) {
  const id = normalizeTerritorioId(comuneId);
  if (!id) return "";
  const mappeFoto = {
    campli: HERO_BY_SLUG.campli || "",
    "castiglione-messer-raimondo": HERO_BY_SLUG["castiglione-messer-raimondo"] || "",
    crognaleto: HERO_BY_SLUG.crognaleto || "",
    "montorio-al-vomano": HERO_BY_SLUG["montorio-al-vomano"] || "",
    montorio: HERO_BY_SLUG["montorio-al-vomano"] || HERO_BY_SLUG.montorio || "",
  };
  if (mappeFoto[id]) return mappeFoto[id];
  return risolviFotoMontorioUfficiale(id);
}

/**
 * Foto gemellaggi (Castelli ↔ Assisi): borgo Castelli, non Camicia.
 * Nessun `/assets/nodi/*` né `https://6amico.com{id}-capoluogo.webp`.
 */
export function risolviFotoGemellaggio(comuneId) {
  const id = normalizeTerritorioId(comuneId);
  if (!id) return "";
  const mappeFotoGemellaggi = {
    castelli: HERO_BY_SLUG.castelli || "/hero/castelli-borgo.jpg",
    assisi: HERO_BY_SLUG.assisi || "",
    "assisi-san-francesco": HERO_BY_SLUG.assisi || HERO_BY_SLUG["assisi-san-francesco"] || "",
    "assisi-storia-origini": HERO_BY_SLUG.assisi || HERO_BY_SLUG["assisi-storia-origini"] || "",
  };
  if (mappeFotoGemellaggi[id]) return mappeFotoGemellaggi[id];
  return fotoCopertinaDaHeroMap(id);
}

/** Link ufficiali: `/comune/:id` · `/citta/:id` · foto da HERO_BY_SLUG o "". */
export function generaLinkUfficialiRete(comuneId, tipo = "comune") {
  const id = normalizeTerritorioId(comuneId);
  let url_comune_6amico;
  if (tipo === "mondo") {
    url_comune_6amico = id ? `/citta/${id}` : "/mondo";
  } else {
    url_comune_6amico = id ? `/comune/${id}` : "/comuni";
  }
  return {
    url_comune_6amico,
    url_foto_copertina: fotoCopertinaDaHeroMap(id),
  };
}

/**
 * Preferisce foto locali certificate.
 * Locale → HERO_BY_SLUG; rete → SIXAMICO_MEDIA.comuni (brand pool).
 */
export function risolviFotoInquadratura(comuneId, haFotoLocale) {
  if (haFotoLocale) {
    return {
      url_foto_finale: risolviFotoMontorioUfficiale(comuneId),
      is_proprietaria: true,
    };
  }
  const reteBrand =
    (SIXAMICO_MEDIA && typeof SIXAMICO_MEDIA.comuni === "string" && SIXAMICO_MEDIA.comuni) ||
    "";
  return {
    url_foto_finale: reteBrand,
    is_proprietaria: false,
  };
}

export function inferHaFotoProprietaria(comuneId, frazioneData) {
  if (frazioneData && typeof frazioneData.ha_foto_proprietaria === "boolean") {
    return frazioneData.ha_foto_proprietaria;
  }
  if (fotoCopertinaDaHeroMap(comuneId)) return true;
  if (fotoCopertinaDaHeroMap((frazioneData && frazioneData.slug_frazione) || "")) return true;
  return false;
}
